import React from 'react';

import ModalPayoutsMarkNotReceivedComponent from './modal-payouts-mark-not-received.component';

export default function ModalPayoutsMarkNotReceived(props) {
    return <ModalPayoutsMarkNotReceivedComponent {...props} />;
}
